import tw, { styled } from 'twin.macro'

// todo: remove !important when fixed style injection order
// https://linear.app/getcircuit/issue/PRO-1639/fix-order-of-global-style-injection
export const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
  ${tw`
    absolute
    z-10
    w-full!
    h-full!
    top-0
    left-0
    opacity-0
    cursor-pointer
  `}
`

export const Container = tw.div`
  relative
  text-left
`

export const Track = styled.div`
  ${tw`
    relative
    z-0
    h-6
    w-11
    bg-gray-200
    border-2
    border-transparent
    rounded-full
    transition-colors
    ease-in-out
    duration-200
    overflow-hidden
    pointer-events-none
  `}

  ${HiddenCheckbox}:checked ~ & {
    ${tw`bg-brand-emphasis`}
  }

  ${HiddenCheckbox}:focus ~ & {
    ${tw`ring-2 ring-offset-2 ring-brand-neutral`}
  }
`

export const Circle = styled.div`
  ${tw`
    relative
    inline-block
    h-5
    w-5
    rounded-full
    bg-default-subdued
    shadow
    transform
    ring-0
    transition-transform
    ease-in-out
    duration-200
    translate-x-0
  `}

  ${HiddenCheckbox}:checked ~ ${Track} & {
    ${tw`translate-x-5`}
  }
`

export const Symbol = styled.div`
  ${tw`w-3 h-3 text-default-muted`}

  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  ${tw`
    invisible
    opacity-0
    transition-opacity
    duration-200
    ease-in-out
  `}

  ${HiddenCheckbox}:checked ~ ${Track} &[data-checked],
  ${HiddenCheckbox}:not(:checked) ~ ${Track} &[data-unchecked] {
    ${tw`visible opacity-100`}
  }
`
